import React, { ReactNode } from 'react';
import { useNavigate} from 'react-router-dom';
import { ThemeToggle } from '../ThemeToggle';
import { LanguageSwitcher } from '../LanguageSwitcher';
import { NotificationIcon } from '../Notification';

interface HeaderProps {
  title?: string;
  showBackButton?: boolean;
  backButtonAction?: () => void;
  rightElement?: ReactNode;
}

const Header: React.FC<HeaderProps> = ({
  title,
  showBackButton = false,
  backButtonAction,
  rightElement
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (backButtonAction) {
      backButtonAction();
    } else {
      navigate(-1);
    }
  };

  return (
    <header 
      className="bg-white dark:bg-gray-800 shadow-sm z-30"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-12 relative">
          <div className="flex items-center">
            {showBackButton && (
              <button
                onClick={handleBack}
                className="mr-2 p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                aria-label="Back"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-gray-600 dark:text-gray-300"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 19l-7-7 7-7"
                  />
                </svg>
              </button>
            )}
            
            {/* Always show logo */}
            <img
              className="h-8 mr-3"
              src="/img/marunetransparentlogo.png"
              alt="Marune"
            />

            {/* Show title if provided */}
            {title && (
              <h1 className="text-xl font-semibold text-gray-900 dark:text-white">
                {title}
              </h1>
            )}
          </div>
          
          <div className="flex items-center space-x-2">
            {rightElement}
            <LanguageSwitcher 
              compact={true}
            />
            <NotificationIcon />
            <ThemeToggle />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;